
      export const versions = {
        commit: '9b6786eafeab95fec91252551e9744af4b6e21aa',
        branch: 'HEAD'
      };
